import { requestGameAdmin, parseResponse } from './auth';

/**
 * GET /api-admin/v0/game/rps/config (admin-game-api)
 */
export async function getGameRpsConfig(accessToken) {
  const res = await requestGameAdmin('/api-admin/v0/game/rps/config', { method: 'GET' }, accessToken);
  return parseResponse(res, '/api-admin/v0/game/rps/config');
}

/**
 * PATCH /api-admin/v0/game/rps/config
 * @param {{
 *   min_wins_for_ranking?: number,
 *   ranking_top_n?: number,
 *   badge_gold_pct?: number,
 *   badge_silver_pct?: number,
 *   badge_bronze_pct?: number,
 * }} body
 */
export async function patchGameRpsConfig(accessToken, body) {
  const res = await requestGameAdmin(
    '/api-admin/v0/game/rps/config',
    { method: 'PATCH', body: JSON.stringify(body) },
    accessToken,
  );
  return parseResponse(res, '/api-admin/v0/game/rps/config');
}

/**
 * GET /api-admin/v0/game/rps/ranking
 * @param {string} accessToken
 * @param {{ period?: string, periodKey?: string, seasonKey?: string }} [opts]
 */
export async function getGameRpsRanking(accessToken, opts = {}) {
  const q = new URLSearchParams();
  if (opts.seasonKey) {
    q.set('season_key', opts.seasonKey);
  } else {
    q.set('period', opts.period || 'weekly');
    if (opts.periodKey) q.set('period_key', opts.periodKey);
  }
  const res = await requestGameAdmin(
    `/api-admin/v0/game/rps/ranking?${q.toString()}`,
    { method: 'GET' },
    accessToken,
  );
  return parseResponse(res, '/api-admin/v0/game/rps/ranking');
}

/**
 * GET /api-admin/v0/game/rps/matches/history
 * @param {string} accessToken admin JWT
 * @param {{ userId: number|string, cursor?: number|string, limit?: number }} opts
 */
export async function getGameRpsHistory(accessToken, { userId, cursor, limit = 20 } = {}) {
  const q = new URLSearchParams({
    user_id: String(userId),
    limit: String(limit),
  });
  if (cursor) q.set('cursor', String(cursor));
  const res = await requestGameAdmin(
    `/api-admin/v0/game/rps/matches/history?${q.toString()}`,
    { method: 'GET' },
    accessToken,
  );
  const payload = await parseResponse(res, '/api-admin/v0/game/rps/matches/history');
  return payload?.data?.matches ?? [];
}

/**
 * GET /api-admin/v0/game/rps/seasons
 */
export async function getGameRpsSeasons(accessToken, limit = 52) {
  const q = new URLSearchParams({ limit: String(limit) });
  const res = await requestGameAdmin(
    `/api-admin/v0/game/rps/seasons?${q.toString()}`,
    { method: 'GET' },
    accessToken,
  );
  return parseResponse(res, '/api-admin/v0/game/rps/seasons');
}
